var exports = {
  "az": "Box__OmxI-U",
  "wy": "Box_1__PrJLXb",
  "N_": "Link__6bzc-7",
  "EY": "Text__or4W4B",
  "UE": "Text_1__IAGajV",
  "Nl": "Text_2__t-FmBX",
  "bx": "Link_1__WKLuM4",
  "pv": "Box_2__wS1t_I",
};

module.exports = exports;
